const AuthDictionary = {
  propertyLogin: () => "auth/signin-rrooms-user",
  userLogin: () => "auth/otpGen",
  userVerify: () => "auth/otpVerify",
  mainPropertyLogin: () => "auth/signin-property-user",
  editUser: (id) => `auth/update-user/${id}`,
  getUserUrl: (id) => `auth/customers/${id}`,
  getRoles: () => `auth/roles`,
  getRoomsUser: () => `auth/rrooms-users`,
  getApp: () => `auth/get-app-url`,
  forgotPasswordPropery: (id) =>
    `auth/property-users/generate-otp-password/${id}`,
  updatePasswordPropery: (id) => `auth/property-users/update-password/${id}`,
  forgotPasswordRrooms: (id) => `auth/rrooms-users/generate-otp-password/${id}`,
  updatePasswordRrooms: (id) => `auth/rrooms-users/update-password/${id}`,
  getPropetyUser: (id) => `auth/property-users/${id}`,
  ownerProperties: () => `auth/owner-all-property`,

  rroomUserChangePassword: (id) => `auth/rrooms-users/change-password/${id}`,
  propertyUserChangePassword: (id) => `auth/property-users/change-password/${id}`,

  rroomUserForgotPassword: () => `auth/rrooms-users/get-user-by-email`,
  propertyUserForgotPassword: () => `auth/property-users/get-user-by-email`,
  generatePropertyUserOtp: () => `auth/property-users/generate-otp-login`,
  loginPropertyUserWithOtp: () => `auth/signin-property-user-by-otp `
};

export default AuthDictionary;
